import {
  MODE_DELIVERY,
  MODE_ONSITE,
  MODE_TAKEAWAY,
  typeOrderTabs,
} from "../../../constants/constants";
import { Restaurant } from "../../../interfaces/Catalogue";
import styles from "./OrderTypeTabs.module.scss";

interface Props {
  restaurant?: Restaurant;
  selectedMode: number | null;
  onSelectMode: (type: number) => void;
  onSelectDelivery: () => void;
}

const OrderTypeTabs = ({ restaurant, selectedMode, onSelectMode, onSelectDelivery }: Props) => {
  const filteredTabs = typeOrderTabs?.filter((tab) => {
    switch (tab.type) {
      case MODE_TAKEAWAY: return restaurant?.aEmporte || false;
      case MODE_ONSITE:   return restaurant?.surPlace || false;
      case MODE_DELIVERY: return restaurant?.livraison || false;
      default:            return false;
    }
  });

  if (filteredTabs.length === 0) return null;

  return (
    <section className={styles.orderTypeSection}>
      <div className={styles.wrapperTab}>
        {filteredTabs.map((tab, index) => (
          <p
            key={index}
            className={selectedMode === tab.type ? styles.activeTab : ""}
            onClick={() =>
              tab.type === MODE_DELIVERY ? onSelectDelivery() : onSelectMode(tab.type)
            }
          >
            {tab.label}
          </p>
        ))}
      </div>
    </section>
  );
};

export default OrderTypeTabs;